import { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import { labelReveal } from './railMotion';

type Theme = 'light' | 'dark';
function applyTheme(t: Theme) {
  document.documentElement.classList.toggle('dark', t === 'dark');
  localStorage.setItem('theme', t);
}

/** A rail row: same fixed-icon-box + gliding-label geometry as the nav rows, so
 *  it stays aligned through the expand/collapse (icon centred while collapsed,
 *  left-gutter with a "Temă" label when expanded). */
export function ThemeToggle({ expanded = false }: { expanded?: boolean }) {
  const [theme, setTheme] = useState<Theme>(() =>
    document.documentElement.classList.contains('dark') ? 'dark' : 'light',
  );
  useEffect(() => { applyTheme(theme); }, [theme]);
  return (
    <button
      type="button"
      aria-label={theme === 'dark' ? 'Comută la tema luminoasă' : 'Comută la tema întunecată'}
      onClick={() => setTheme((t) => (t === 'dark' ? 'light' : 'dark'))}
      className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md text-ink-2 hover:bg-wash ${
        expanded ? 'md:w-full md:justify-start md:pl-1' : ''
      }`}
    >
      <span className="grid size-10 shrink-0 place-items-center">
        {theme === 'dark' ? <Sun className="size-5" /> : <Moon className="size-5" />}
      </span>
      <span className={`text-[13.5px] font-medium ${labelReveal(expanded)}`}>Temă</span>
    </button>
  );
}
